const User = require('module/user/user')
const UserDefaults = require('module/user/user_defaults')
const deep_defaults = require('lib/deep_defaults')
const log = require('log').create('profile_user') // eslint-disable-line


const ProfileUser = User.extend({

    // subclass of User with entire data structure instantiated

    // this causes a significant performance hit, so can't do this to base User model
    // profile page uses this model instead of the base User model
    // viewer model inherits from this model

    defaults: UserDefaults,

    parse(attrs, options) {
        // make sure all nested objects in returned attributes have an ID defined
        // this is needed so backbone-associations will merge attributes instead overwriting whole objects
        return deep_defaults(
            attrs,
            UserDefaults,
            {
                whitelist: ['id'],
                add_undefined_objects: false,
            }
        )
    },

})

module.exports = ProfileUser
